import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { BASE_URL } from './helpers';
import { IWorkflowServiceRequestTemplateResponse } from './types';

/** The task groups and task keys a workflow's steps bind against, as its links decide. */
export const useWorkflowServiceRequestTemplate = (
  workflowTemplateId?: string
) => {
  const { data, error, isLoading } =
    useSWR<IWorkflowServiceRequestTemplateResponse>(
      workflowTemplateId
        ? `${BASE_URL}/${workflowTemplateId}/service-request-template`
        : null,
      SWRFetcher({ method: 'GET' })
    );

  return { template: data?.template, error, isLoading };
};
